<template>
    <div>

        <rkm-area
            no-margin-top
            title="Filtro"
            type="fieldset"
        >
            <rkm-form ref="RkmForm">
                <rkm-row>

                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            :max-date="additionals.dataAtual"
                            :validations="validations.data"
                            label="Data"
                            v-model="model.data"
                        />
                    </rkm-col>

                    <rkm-col class="4">
                        <rkm-form-select
                            :options="form.tiposAtendimento"
                            label="Tipo de atendimento"
                            show-default-option
                            text-field="text"
                            defaultOptionText="Todos"
                            v-model="model.tipoAtendimento"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            :validations="validations.unidade"
                            @change="handleUnidadeChange"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                            :disabled="model.data ? false : true"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                        :options="form.infraestruturas"
                        :validations="validations.infraestrutura"
                        @change="handleInfraestruturaChange"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                        :disabled="model.unidadeId ? false : true"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.especialidades"
                            @change="handleEspecialidadeChange"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            defaultOptionText="Todos"
                            v-model="model.especialidadeId"
                            value-field="id"
                            :disabled="model.infraestruturaId ? false : true"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            label="Profissional"
                            @change="handleProfissionalChange"
                            show-default-option
                            text-field="nome"
                            defaultOptionText="Todos"
                            v-model="model.usuarioId"
                            value-field="id"
                            :disabled="model.infraestruturaId ? false : true"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="search"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="clean"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="isSearch"
            no-margin-top
            title="Atribuir"
            type="fieldset"
        >
            <rkm-form ref="RkmFormAtribuir">

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="especialidadesJornada"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="atribuir.especialidadeId"
                            value-field="id"
                            @change="handleUsuariosJornadaChange()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="usuariosJornada"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="atribuir.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols=6>
                        <rkm-form-input-autocomplete
                            :repository="repositories.procedimento"
                            :requestQueryStringParams="autocompletesRequestParams.queryString.procedimento"
                            :searchFields="fields.procedimento"
                            :text-field="p => `${formatProcedimento(p.codigo)} - ${p.nome}`"
                            label="Procedimento padrão"
                            v-rkm-tooltip.hover
                            v-model="atribuir.procedimento"
                            @input="handleProcedimento()"
                        >
                            <template v-slot:itemLabel="{ item }">
                                {{ formatProcedimento(item.codigo) }} - {{ item.nome }}
                            </template>

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="additionals.searchByApelido">
                                        <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                        <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>

                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="$refs.ModalProcedimentos.open(atribuir)"
                                    color="primary"
                                    title="Adicionar procedimentos"
                                >
                                    <rkm-icon icon="plus" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cid"
                            :requestQueryStringParams="autocompletesRequestParams.queryString.cid"
                            :searchFields="fields.cid"
                            :text-field="p => `${p.codigo} - ${p.nome}`"
                            label="CID Padrão"
                            v-rkm-tooltip.hover
                            v-model="atribuir.cid"
                        >
                            <template v-slot:itemLabel="{ item }">
                                {{ formatCid(item.codigo) }} - {{ item.nome }}
                            </template>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="additionals.locaisAtendimento"
                            label="Local de atendimento"
                            text-field="descricao"
                            v-model="atribuir.atencaoBasicaLocalAtendimentoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="additionals.status"
                            label="Status padrão"
                            show-default-option
                            text-field="nome"
                            v-model="atribuir.statusId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="handleAtribuir"
                            color="primary"
                            :disabled="handleDisabled()"
                        >
                            Atribuir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="cleanAtribuir"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <ModalProcedimentos
            ref="ModalProcedimentos"
            :filtro="{form, model}"
        />
    </div>
</template>

<script>
// Components.
import ModalProcedimentos from './components/atribuir/procedimentos/Modal'

// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

//Enums
import localAtendimento from '@/enums/atencao-basica/marcador-consumo-alimentar/localAtendimento'
import agendamentoStatus from '@/enums/ambulatorio/agendamentoStatus'

export default {
    components: {
        ModalProcedimentos
    },
    computed: {
        validations() {
            return {
                data: {required: true},
                unidade: {required: true},
                infraestrutura: {required: true},
            }
        },
        fields() {

            return {
                procedimento: [
                    this.additionals.searchByApelido
                        ? { key: 'parametrizacao_procedimento.apelido', searchable: true }
                        : { key: 'nome', searchable: true }, { key: 'codigo', searchable: true }
                ],
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        autocompletesRequestParams() {

            return {
                queryString: {
                    procedimento: {
                        search_by_apelido: this.additionals.searchByApelido || false,
                        cbo: this.atribuir.ocupacaoId,
                    },
                    cid: {
                        procedimento_id: this.model.procedimento && this.model.procedimento.hasCidPrincipal
                            ? this.model.procedimento.id
                            : null
                    }
                },
            }
        },
    },
    created() {
        this.repositories = {
            fechamento: this.getConectaSusRepository('ambulatorio.fechamentoConsulta'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    data: () => ({
        others: {moment},
        atribuir: {
            procedimento: null,
            cid: null,
            statusId: null,
            atencaoBasicaLocalAtendimentoId: null,
            procedimentos: [],
            usuarioId: null,
            ocupacaoId: null,
            especialidadeId: null,
        },
        isSearch: false,
        enums: {
            localAtendimento,
            agendamentoStatus
        },
        ocupacoesJornada: [],
        especialidadesJornada: [],
        usuariosJornada: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUnidadeChange(value) {
            this.$emit('cleaned', [])

            this.additionals.searchByApelido = false
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'infraestruturas',
                data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: value,
                tipoAtendimento: this.model.tipoAtendimento,
            }

            this.setLoading()

            this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.$emit('cleaned', [])

            this.form.especialidades = []
            this.form.usuarios = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'especialidades',
                data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
                tipoAtendimento: this.model.tipoAtendimento,
            }

            this.setLoading()

            this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = response.data.especialidades

                    if (this.model.tipoAtendimento === 'demandaEspontanea' && response.data.especialidades.length === 0) {

                        this.handleEspecialidadeChange()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.$emit('cleaned', [])

            this.form.usuarios = []
            this.model.usuarioId = null
            this.isSearch = false

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'usuarios',
                data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: value,
                tipoAtendimento: this.model.tipoAtendimento,
            }

            this.setLoading()

            this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = response.data.usuarios
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuariosJornadaChange() {

            if (this.atribuir.especialidadeId) {

                const especialidade = this.especialidadesJornada
                        .find(especialidade => especialidade.id === this.atribuir.especialidadeId);

                const ocupacaoId = especialidade.ocupacao.id;

                const request = {
                    data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                    unidadeId: this.model.unidadeId,
                    infraestruturaId: this.model.infraestruturaId,
                    ocupacaoId: ocupacaoId,
                    especialidadeId: this.atribuir.especialidadeId,
                }

                this.setLoading()

                this.repositories.fechamento.getUsuariosWithJornada(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.usuariosJornada = response.data
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.usuariosJornada = []
            }
        },
        handleTipoAtendimentoChange() {

            this.$emit('cleaned', [])

            this.additionals.searchByApelido = false
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false
            this.atribuir.atencaoBasicaLocalAtendimentoId = this.enums.localAtendimento.UBS

            if (this.model.data) {

                const request = {
                    origem: 'busca',
                    listar: 'unidades',
                    data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                    tipoAtendimento: this.model.tipoAtendimento,
                }

                this.setLoading()

                this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleProfissionalChange() {
            this.$emit('cleaned', [])
            this.isSearch = false
        },
        search() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                        unidadeId: this.model.unidadeId,
                        infraestruturaId: this.model.infraestruturaId,
                        especialidadeId: this.model.especialidadeId,
                        usuarioId: this.model.usuarioId,
                        tipoAtendimento: this.model.tipoAtendimento
                    }

                    this.setLoading()

                    this.repositories.fechamento.index(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.$emit('searched', response.data)
                            this.especialidadesJornada = response.data.especialidades
                            this.isSearch = true
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        handleAtribuir() {

            this.$refs.RkmFormAtribuir.validate()
                .then(valid => {
                    if (valid === false) return

                    this.consultas.filter(consulta => consulta.selecionado).map((item) => {

                        item.atencaoBasicaLocalAtendimentoId = this.atribuir.atencaoBasicaLocalAtendimentoId
                        item.statusId = this.atribuir.statusId

                        if (item.statusId === this.enums.agendamentoStatus.REALIZADO) {

                            const especialidade = this.especialidadesJornada
                                .find(especialidade => especialidade.id === this.atribuir.especialidadeId);

                            item.procedimento = this.atribuir.procedimento
                            item.cid = this.atribuir.cid

                            if (!item.usuarioNome && especialidade && this.handlePermissaoEspecialidade(item, especialidade)) {
                                item.usuarioId = this.atribuir.usuarioId
                                item.usuariosJornada = this.usuariosJornada
                                item.especialidadesJornada = this.especialidadesJornada
                                item.especialidadeId = this.atribuir.especialidadeId
                                item.ocupacaoId = especialidade.ocupacao.id;
                                item.criaFichaAtendimentoIndividual = especialidade.criaFichaAtendimentoIndividual
                                item.criaFichaAtendimentoOdontologico = especialidade.criaFichaAtendimentoOdontologico
                            }

                            this.atribuir.procedimentos.forEach(procedimento => {
                                const existe = item.procedimentos.some(itemProcedimento => itemProcedimento === procedimento);

                                if (!existe) {
                                    item.procedimentos.push(procedimento);
                                }
                            });
                        } else {
                            item.procedimento = null
                            item.cid = null
                            item.procedimentos = []
                        }
                    })
                })
        },
        handlePermissaoEspecialidade(item, especialidade) {

            if (especialidade.sexoId && especialidade.sexoId != item.cidadaoPacienteSexoId) {

                return false
            }

            if (especialidade.idadeMinima && item.cidadaoPacienteIdadeAnos < especialidade.idadeMinima) {

                return false
            }

            if (especialidade.idadeMaxima && item.cidadaoPacienteIdadeAnos > especialidade.idadeMaxima) {

                return false
            }

            return true
        },
        handleProcedimento() {

            if (this.atribuir.procedimento && this.atribuir.procedimento.id) {

                const index = this.atribuir.procedimentos.findIndex(procedimento => procedimento.id === this.atribuir.procedimento.id)

                if (index !== -1) {

                    this.atribuir.procedimentos.splice(index, 1)
                }
            }
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.$emit('cleaned', [])

            this.additionals.searchByApelido = false

            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []

            if (this.model.data == this.others.moment(this.additionals.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD')
                && this.model.tipoAtendimento == null) {

                this.handleTipoAtendimentoChange()
            }

            this.model.data = this.others.moment(this.additionals.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD')
            this.model.tipoAtendimento = null

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false

            this.$refs.RkmForm.resetValidator()
        },
        cleanAtribuir() {
            this.atribuir.procedimento = null
            this.atribuir.cid = null
            this.atribuir.statusId = null
            this.atribuir.especialidadeId = null
            this.atribuir.usuarioId = null
            this.atribuir.atencaoBasicaLocalAtendimentoId = null
            this.atribuir.procedimentos = []
            this.usuariosJornada = []

            this.$refs.RkmFormAtribuir.resetValidator()
        },
        handleDisabled() {
            return this.consultas.filter(consulta => consulta.selecionado).length === 0 ? true : false
        }
    },
    mixins: [error, formats, repository, stringCase],
    props: {
        additionals: {type: Object, required: true},
        form: {type: Object, required: true},
        model: {type: Object, required: true},
        consultas: {type: Array, required: true},
    },
    mounted() {

        const request = {
            origem: 'busca',
            listar: 'unidades',
            data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
            tipoAtendimento: this.model.tipoAtendimento,
        }

        this.setLoading()

        this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
            .then(response => {
                this.form.unidades = Object.assign(response.data.unidades)
                this.atribuir.atencaoBasicaLocalAtendimentoId = this.enums.localAtendimento.UBS
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
    },
    watch: {
        'model.data'() {

            this.$emit('cleaned', [])

            this.additionals.searchByApelido = false
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false
            this.atribuir.atencaoBasicaLocalAtendimentoId = this.enums.localAtendimento.UBS

            if (this.model.data) {

                const request = {
                    origem: 'busca',
                    listar: 'unidades',
                    data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                    tipoAtendimento: this.model.tipoAtendimento,
                }

                this.setLoading()

                this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        'model.tipoAtendimento'() {

            this.handleTipoAtendimentoChange()
        },
    },
}
</script>